import ApiKeys from "./apiKeys";
import Apiencryption from "./apiencryption";
import Pushconfig from "./pushconfig";

const DeveloperConfig = () => {
   
    return (
        <div>
            <div className='loader-static'>
                <div className="grid md:grid-cols-2 gap-4 md:mb-7 mb-4">
                  <div>
                    <h2 className="text-titleColor text-2xl font-semibold md:mb-2 md:mt-4">API Keys</h2>
                    <p className="text-paraColor text-sm font-normal"></p>
                  </div>
                  <div className="">
                      <ApiKeys/>
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4 md:mb-7 mb-4">
                  <div>
                    <h2 className="text-titleColor text-2xl font-semibold md:mb-2 md:mt-4">API Encryption</h2>
                    <p className="text-paraColor text-sm font-normal"></p>
                  </div>
                  <div>
                      <Apiencryption/>
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <h2 className="text-titleColor text-2xl font-semibold md:mb-2 md:mt-4">Webhook</h2>
                    <p className="text-paraColor text-sm font-normal">Common push scenarios include card deposit, card activation, consumption, freeze and UnFreeze etc.</p>
                  </div>
                  <div className="">
                      <Pushconfig/>
                  </div>
                </div>
            </div>
        </div>
    )
}
export default DeveloperConfig;